/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { object, shape, string } from 'prop-types';
import mbpLogger from 'mbp-logger';
import { compose } from 'recompose';
import { Query } from '@apollo/client/react/components';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import ReactMarkdown from 'react-markdown';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@material-ui/core';
import findContentPage from '../../../../../../../../../../gql/queries/findContentPage';
import { getBrand } from '../../../../../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import ContentPageBlockStyle from '../../../../../../../../../../components/GraphqlComponents/GraphqlContentPage/style/ContentPageBlockStyle';
import ShippingInfo from './ShippingInfo';
// eslint-disable-next-line react/prefer-stateless-function
const styles = (theme) => ContentPageBlockStyle(theme);

const Content = (block, index, classes) => {
    const blockKey = Object.keys(block)?.[0];
    const blockObj = block[blockKey];
    switch (blockKey) {
        case 'copy':
            return <ReactMarkdown source={blockObj.copy} className={`${classes.markdown} ${classes.pageBreak}`} escapeHtml={false} />;

        case 'tabular_data':
            return <ReactMarkdown source={blockObj.table} className={`${classes.markdown} ${classes.markdownTable} ${classes.pageBreak}`} escapeHtml={false} />;

        case 'tabular_data_list':
            return (
                <>
                    {blockObj.title && (<p className={classes.tableTitle}>{blockObj.title}</p>)}
                    <TableContainer>
                        <Table className={classes.table}>
                            {(blockObj.group_head.col_big && blockObj.group_head.col_sm)
                                && (
                                    <TableHead className={classes.tableHead}>
                                        <TableCell className={classes.tableCellHead}>{blockObj.group_head.col_big}</TableCell>
                                        <TableCell className={classes.tableCellHead}>{blockObj.group_head.col_sm}</TableCell>
                                    </TableHead>
                                )}
                            <TableBody>
                                {
                                    blockObj.group.map((price) => {
                                        if (price.col_sm && price.col_big) {
                                            return (
                                                <TableRow className={classes.tableBody}>
                                                    <TableCell className={classes.tableCell}>
                                                        {price.col_big}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell} width="20%">
                                                        {price.col_sm}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        }
                                        return null;
                                    })
                                }
                            </TableBody>
                        </Table>

                    </TableContainer>
                </>
            );
        default:
            return <></>;
    }
};

class ShippingInfoCMS extends Component {
    render() {
        const { brand, classes } = this.props;
        const path = '/shipping-information-modal';
        const SHIPPING_INFO_QUERY = findContentPage(brand['domain-name'], path);

        return (
            <Query query={SHIPPING_INFO_QUERY}>
                {({ loading, error, data }) => {
                    if (loading) {
                        // TODO: Add spinner graphic
                        return <ReactMarkdown source="loading..." />;
                    }
                    if (error) {
                        return <ShippingInfo />;
                    }
                    if (data) {
                        const respData = data?.findContentPage?.content?.entries;
                        const blockData = respData?.[0]?.center_blocks;
                        if (!respData || !blockData?.length) {
                            mbpLogger.logDebug({
                                appName: process.env.npm_package_name,
                                message: `ShippingInfoCMS.js | ${brand} has no cms shipping data. Falling back to hard-coded tables.`,
                            });
                            return <ShippingInfo />;
                        }

                        return (
                            blockData.map((block, index) => (
                                Content(block, index, classes)
                            ))
                        );
                    }
                    mbpLogger.logDebug({
                        appName: process.env.npm_package_name,
                        message: `ShippingInfoCMS.js | ${brand} has no cms shipping data. Falling back to hard-coded tables.`,
                    });

                    return <ShippingInfo />;
                }}

            </Query>
        );
    }
}
const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

ShippingInfoCMS.propTypes = {
    brand: shape({
        'domain-name': string,
    }).isRequired,
    classes: object.isRequired,
};
const enhance = compose(
    connect(mapStateToProps),
    withStyles(styles),
);

export default enhance(ShippingInfoCMS);
